import { CSSProperties, FC, useContext, useMemo } from "react";

import { Grid, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { LanguageSwitcher } from "@/common/components";
import { EnrollmentContext } from "@/state";
import "./ThemedHeader.scss";


const CONTAINER_HEIGHT = "80px";

export const ThemedHeader: FC = () => {
  const [state] = useContext(EnrollmentContext);
  const theme = state.experienceData?.theme;
  const { setLogoFlush } = useResponsive(
    useMemo(
      () => ({
        setLogoFlush: { desktop: false, tablet: false, mobile: true },
      }),
      [],
    ),
  );

  return (
    <div className={setLogoFlush ? "themed-header themed-header-mobile" : "themed-header"}>
      <Grid>
        {!setLogoFlush && <Grid.Span columns={1} />}
        <Grid.Span columns={setLogoFlush ? 12 : 10}>
          <Shelf alignment="center">
            <div className="themed-header-logo-container">
              <img className="themed-header-logo" src={theme?.logo_desktop} alt="client logo" />
            </div>
            <Shelf.Spacer />
            <LanguageSwitcher />
          </Shelf>
        </Grid.Span>
        {!setLogoFlush && <Grid.Span columns={1} />}
      </Grid>
    </div>
  );
};

export const ThemedGradient: FC = () => {
  const [state] = useContext(EnrollmentContext);
  const theme = state.experienceData?.theme;
  const style: CSSProperties = {
    borderBottom: `solid 6px ${theme?.primary_color || "#313e48"}`,
    top: CONTAINER_HEIGHT,
  };

  return <div className="themed-gradient" style={style} />;
};
